// 设置 Vue 3 feature flags
window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
window.__VUE_PROD_DEVTOOLS__ = false;
window.__VUE_OPTIONS_API__ = true;
window.__VUE_PROD_TIPS__ = false;

import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import App from './App.vue'
import router from './router'
import store from './store'

const app = createApp(App)


// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(ElementPlus)
app.use(store)
app.use(router)

app.mount('#app')